import React from 'react';
import { motion } from 'framer-motion';
import useT from '../../../i18n';

/**
 * Trust strip — compact section between hero and value proposition.
 * Uses editorial wordmarks (not logo images) in muted ink/30 for magazine feel.
 */
export default function TrustStrip() {
  const t = useT();
  const s = t.landingV2.trust;
  return (
    <section
      className="bg-paper py-16 md:py-20 border-t border-ink/[0.06]"
      data-testid="landing-trust"
    >
      <div className="max-w-editorial mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-sans text-xs uppercase tracking-widest text-ink/50">
            {s.eyebrow}
          </p>
          <p className="mt-4 font-sans text-base md:text-lg text-ink/70 max-w-prose-wide leading-relaxed">
            {s.body}
          </p>

          <div
            className="mt-12 flex flex-wrap items-center gap-x-12 gap-y-5 border-t border-ink/[0.08] pt-8"
            data-testid="trust-logos"
          >
            {s.logos.map((label) => (
              <span
                key={label}
                className="font-sans text-sm uppercase tracking-wider text-ink/30"
              >
                {label}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
